import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'NESN',
    callsign: 'nesn',
    logoUrl: networkLogos.nesn.logoUrl,
    slug: 'nesn',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="nesn"
        title="Watch NESN live online with Fubo"
        networkName="NESN"
      />
    </>
  )
}
